module.exports = __webpack_public_path__ + "static/img/indexSoftware1.3cba25c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/indexSoftware1.png
// module id = 9Uv1
// module chunks = 2